import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Col } from "../../layout";
import { PopoverPosition } from "../../popover";
import { CALENDAR_WRAPPER_MAX_WIDTH } from "../date-picker-calendar/constants";
import { dateRangePickerDefaultProps } from "../constants";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var POPOVER_WIDTH = CALENDAR_WRAPPER_MAX_WIDTH;
var defaultInputProps = {};
var defaultPopoverProps = {
  position: PopoverPosition.BottomTrailing
};
export var defaultPopupDatePickerProps = {
  calendarButtonAltText: 'Calendar',
  collapsedTitleText: 'Select a date',
  collapsedCloseButtonAltText: 'Close date picker',
  inputProps: defaultInputProps,
  popoverProps: defaultPopoverProps,
  renderPopupContent: function (_ref) {
    var calendar = _ref.calendar,
        legend = _ref.legend;
    return ___EmotionJSX(Col, {
      gridGap: "S200"
    }, calendar, legend);
  }
};
export var defaultPopupDateRangePickerProps = _objectSpread(_objectSpread({}, defaultPopupDatePickerProps), {}, {
  ariaLabelsForSelectedDate: dateRangePickerDefaultProps.ariaLabelsForSelectedDate,
  collapsedTitleText: 'Select dates',
  startDateLabelText: 'Start date',
  endDateLabelText: 'End date',
  showSelectedDaysText: false,
  getSelectedDaysText: function getSelectedDaysText(days) {
    return "".concat(days, " day").concat(days > 1 ? 's' : '', " selected");
  },
  shouldCloseOnDateSelection: true
});